export function Step3Icon3() {
    return (
        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="27.5" cy="28.5" r="14.5" stroke="#9B4DF6" strokeWidth="2" />
            <path
                d="M27.5 9C28.3284 9 29 8.34192 29 7.53019V2.46981C29 1.65808 28.3284 1 27.5 1C26.6716 1 26 1.65808 26 2.46981V7.53019C26 8.34192 26.6716 9 27.5 9Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M53.5302 27H48.4698C47.6581 27 47 27.6716 47 28.5C47 29.3284 47.6581 30 48.4698 30H53.5302C54.3419 30 55 29.3284 55 28.5C55 27.6716 54.3419 27 53.5302 27Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M27.5 47C26.6716 47 26 47.6581 26 48.4698V53.5302C26 54.3419 26.6716 55 27.5 55C28.3284 55 29 54.3419 29 53.5302V48.4698C29 47.6581 28.3284 47 27.5 47V47Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M9 28.5C9 27.6716 8.34192 27 7.53019 27H2.46981C1.65808 27 1 27.6716 1 28.5C1 29.3284 1.65808 30 2.46981 30H7.53019C8.34192 30 9 29.3284 9 28.5Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M42.5786 15C42.9826 15 43.3866 14.8459 43.6947 14.5376L47.5376 10.6947C48.1541 10.0782 48.1541 9.07882 47.5376 8.46235C46.9213 7.84588 45.9217 7.84588 45.3053 8.46235L41.4624 12.3052C40.8459 12.9217 40.8459 13.9211 41.4624 14.5376C41.7707 14.8459 42.1747 15 42.5786 15V15Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M43.6947 41.4623C43.0784 40.8459 42.0788 40.8459 41.4624 41.4623C40.8459 42.0788 40.8459 43.0782 41.4624 43.6947L45.3054 47.5377C45.6136 47.8459 46.0176 48 46.4215 48C46.8254 48 47.2295 47.8458 47.5376 47.5376C48.1541 46.9211 48.1541 45.9216 47.5376 45.3052L43.6947 41.4623Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M12.3053 41.4624L8.46236 45.3052C7.84588 45.9217 7.84588 46.9211 8.46236 47.5376C8.7706 47.8458 9.17461 48 9.57851 48C9.98242 48 10.3865 47.8459 10.6947 47.5376L14.5376 43.6947C15.1541 43.0782 15.1541 42.0788 14.5376 41.4624C13.9214 40.8459 12.9217 40.8459 12.3053 41.4624V41.4624Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M12.3054 14.5376C12.6136 14.8458 13.0176 15 13.4215 15C13.8254 15 14.2295 14.8459 14.5376 14.5376C15.1541 13.9211 15.1541 12.9217 14.5376 12.3052L10.6947 8.46235C10.0784 7.84588 9.07883 7.84588 8.46236 8.46235C7.84588 9.07882 7.84588 10.0782 8.46236 10.6947L12.3054 14.5376Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M34.9279 10.8814C35.1169 10.9619 35.3125 11 35.505 11C36.095 11 36.6551 10.6418 36.8956 10.0478L38.8844 5.13757C39.2034 4.34988 38.8397 3.44595 38.072 3.11863C37.3044 2.7914 36.4235 3.16434 36.1043 3.95213L34.1156 8.86234C33.7967 9.65012 34.1603 10.5541 34.9279 10.8814Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M52.0478 36.1044L47.1376 34.1157C46.3498 33.7966 45.446 34.1602 45.1187 34.928C44.7913 35.6957 45.1645 36.5766 45.9522 36.8957L50.8624 38.8844C51.0563 38.9629 51.257 39 51.4545 39C52.0599 39 52.6345 38.6509 52.8813 38.072C53.2087 37.3044 52.8355 36.4234 52.0478 36.1044V36.1044Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M21.0721 45.1186C20.3043 44.7914 19.4234 45.1643 19.1044 45.9521L17.1156 50.8624C16.7966 51.6501 17.1603 52.5541 17.928 52.8814C18.1169 52.9619 18.3125 53 18.5051 53C19.0951 53 19.6551 52.6418 19.8957 52.0478L21.8844 47.1375C22.2033 46.3499 21.8397 45.446 21.0721 45.1186V45.1186Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M3.95216 19.8956L8.86239 21.8844C9.05628 21.9629 9.25696 22 9.45455 22C10.0599 22 10.6345 21.6509 10.8813 21.0719C11.2087 20.3042 10.8355 19.4233 10.0478 19.1042L5.13761 17.1156C4.34992 16.7967 3.44598 17.1602 3.11865 17.9279C2.79133 18.6956 3.16447 19.5766 3.95216 19.8956Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M45.1172 21.0667C45.363 21.6485 45.9383 22 46.5446 22C46.7408 22 46.9403 21.9632 47.133 21.8854L52.045 19.9034C52.8329 19.5855 53.2081 18.7035 52.8828 17.9333C52.5574 17.1631 51.6548 16.7966 50.867 17.1146L45.955 19.0965C45.167 19.4146 44.7919 20.2966 45.1172 21.0667Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M36.9035 45.9549C36.5856 45.1669 35.7034 44.792 34.9334 45.1172C34.1632 45.4424 33.7966 46.3449 34.1145 47.1329L36.0965 52.0451C36.3368 52.6404 36.899 53 37.4915 53C37.6833 53 37.8783 52.9623 38.0666 52.8828C38.8368 52.5575 39.2034 51.6549 38.8855 50.867L36.9035 45.9549Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M10.8828 34.9334C10.5575 34.1633 9.65529 33.7965 8.86706 34.1146L3.95501 36.0966C3.16708 36.4145 2.7919 37.2965 3.11717 38.0667C3.36301 38.6485 3.93813 39 4.54453 39C4.74067 39 4.9403 38.9632 5.13293 38.8854L10.045 36.9035C10.833 36.5855 11.2081 35.7035 10.8828 34.9334V34.9334Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
            <path
                d="M19.0965 10.0451C19.3368 10.6404 19.899 11 20.4915 11C20.6833 11 20.8783 10.9623 21.0666 10.8828C21.8368 10.5575 22.2034 9.65506 21.8855 8.86702L19.9035 3.95494C19.5855 3.16691 18.7033 2.79193 17.9334 3.1172C17.1632 3.44248 16.7966 4.34504 17.1145 5.13297L19.0965 10.0451Z"
                stroke="#9B4DF6"
                strokeWidth="2"
            />
        </svg>
    )
}
